<template>
  <div class="reorganize-tree-transactions-item">
    <TransactionFormDate :instance="transaction"  size="xs" class="reorganize-tree-transactions-item__date" />
    <div class="reorganize-tree-transactions-item__type">{{ type }}</div>
    <div class="reorganize-tree-transactions-item__entries"><Entries :transaction /></div>
    <UIButton
      v-tooltip.top="'Delete transaction'"
      variant="danger"
      fill="light"
      size="xs"
      :leading="TrashIcon"
      @click="handleClickDelete"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { TransactionClass } from '@types'

import { TRANSACTION_FIELD } from '@/const'

import TransactionFormDate from '@/entities/transactions/components/TransactionFormDate.vue'
import Entries from './components/Entries.vue'

import { TrashIcon } from '@heroicons/vue/24/outline'
import { UIButton } from '@ui/buttons'

type Props = {
  transaction: TransactionClass
}

type Emits = {
  delete: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const type = computed(() => props.transaction.field<string>(TRANSACTION_FIELD.TYPE).value)

const handleClickDelete = () => emit('delete')
</script>

<style scoped>
.reorganize-tree-transactions-item {
  @apply flex flex-col sm:flex-row sm:items-center gap-2;
  @apply border border-common-border hover:border-primary-selected dark:hover:border-gray-500;
  @apply bg-body rounded-md;
  @apply py-2.5 px-2;
  @apply text-sm;
  @apply text-gray-400;

  &__date {
    @apply w-[7.5rem] sm:w-[6.5rem];
    @apply shrink-0;
  }

  &__type {
    @apply font-medium;
    @apply text-primary-active dark:text-indigo-300;
    @apply whitespace-nowrap;
  }

  &__entries {
    @apply flex-auto;
    @apply overflow-hidden;
  }
}
</style>
